import React from "react";
import * as Babel from '@babel/standalone';

const timeAgo = (timestamp: string | number | Date): string => {
    const _now: Date = new Date();
    const timeStampDate: Date = new Date(timestamp);

    const diff: number = _now.getTime() - timeStampDate.getTime();

    const seconds: number = Math.floor(diff / 1000);
    const minutes: number = Math.floor(seconds / 60);
    const hours: number = Math.floor(minutes / 60);
    const days: number = Math.floor(hours / 24);
    const weeks: number = Math.floor(days / 7);
    const months: number = Math.floor(days / 30);
    const years: number = Math.floor(days / 365);

    if (years > 0) {
        return years === 1 ? '1 year ago' : `${years} years ago`;
    } else if (months > 0) {
        return months === 1 ? '1 month ago' : `${months} months ago`;
    } else if (weeks > 0) {
        return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
    } else if (days > 0) {
        return days === 1 ? '1 day ago' : `${days} days ago`;
    } else if (hours > 0) {
        return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
    } else if (minutes > 0) {
        return minutes === 1 ? '1 min ago' : `${minutes} mins ago`;
    } else {
        return 'just now';
    }
}

export const getFuncParseValue = (value) => {
    try {
        const compiledCode = Babel.transform(value, { presets: ['react'] }).code;
        const fn = new Function('React', `return ${compiledCode}`);
        const parsedFn = fn(React); // Get the result of JSX evaluation
        if (typeof parsedFn === 'function') {
            return parsedFn;
        }
        return;
    } catch (error) {
        console.error('Error parsing function value:', error);
        return;
    }
}


export const numberToWordsInIndianFormat = (num: number): string => {
    if (!num && num !== 0) return "";

    if (num === 0) return "Zero";

    const ones = [
        "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
        "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
        "Sixteen", "Seventeen", "Eighteen", "Nineteen",
    ];

    const tens = [
        "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy",
        "Eighty", "Ninety",
    ];

    const numToWords = (n: number): string => {
        if (n < 20) return ones[n];
        if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
        if (n < 1000)
            return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + numToWords(n % 100) : "");
        return "";
    };

    let result = "";
    const crore = Math.floor(num / 10000000);
    if (crore) {
        result += numToWords(crore) + " Crore ";
        num %= 10000000;
    }

    const lakh = Math.floor(num / 100000);
    if (lakh) {
        result += numToWords(lakh) + " Lakh ";
        num %= 100000;
    }

    const thousand = Math.floor(num / 1000);
    if (thousand) {
        result += numToWords(thousand) + " Thousand ";
        num %= 1000;
    }

    const hundredOrLess = num;
    if (hundredOrLess) {
        result += numToWords(hundredOrLess);
    }

    return result.trim();
};

export const formatPriceIndian = (number) => {
    if (!number) {
        return number
    }

    if (number.toString().includes('-')) {
        const parts = number.toString().split('-');
        return `${formatPriceIndian(parseInt(parts[0].trim()))} - ${formatPriceIndian(parseInt(parts[1]))}`;
    }

    return parseInt(number).toLocaleString('en-IN');
}

export default timeAgo;
